import React from 'react';
import { useTranslation } from 'react-i18next';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';
import ExoStepper, { FinalPageCreate } from '../../../components/exo/ExoStepper';
import { StepConnection } from '../../../components/steps/StepConnection';
import { StepStorageOptions } from '../../../components/steps/StepStorageOptions';

/**
 * Two-step wizard for creating / editing a network storage:
 *  1. Connection - collect credentials or run OAuth, then persist the storage.
 *  2. Options - browse the connected storage to pick root / project folders
 *     and (for online providers) the namespace.
 */
export const NetworkStorageForm = ({
  startDataCollection,
  startStep = 0,
  onCreate,
  onClose,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const steps = [
    {
      label: t('Connection'),
      valid: true,
      noControlls: true,
      content: (props) => <StepConnection {...props} onClose={onClose} />,
    },
    {
      label: t('Options'),
      valid: true,
      content: (props) => <StepStorageOptions {...props} />,
    },
  ];

  const finalStep = {
    noReset: true,
    operation: ({ dataCollection, handleResponse, handleError, setIsLoading }) => {
      const payload = {
        rootDirectory: dataCollection.rootDirectory ?? '',
        projectRootDirectory: dataCollection.projectRootDirectory ?? '',
        setupCompleted: true,
      };
      ['teamFolderId', 'driveId', 'directoryType'].forEach((key) => {
        if (dataCollection[key] != null) payload[key] = dataCollection[key];
      });

      DBRequest({
        config,
        path: `network-storages/${dataCollection.id}`,
        method: API_PATCH(payload),
        onResponse: handleResponse,
        onError: handleError,
        onLoading: setIsLoading,
      });
    },
    content: (response) => (
      <FinalPageCreate response={response} onCreate={onCreate} />
    ),
  };

  return (
    <ExoStepper
      label={t('Network Storage')}
      data={steps}
      finalStep={finalStep}
      startStep={startStep}
      startDataCollection={startDataCollection || {}}
      onClose={onClose}
      syncHoai={false}
    />
  );
};
